module.exports = __webpack_public_path__ + "media/3_35.6001276d.wav";